<template>
<div class="monthly-view">
	<div class="days-of-week-headings">
		<div>Sun</div>
		<div>Mon</div>
		<div>Tue</div>
		<div>Wed</div>
		<div>Thu</div>
		<div>Fri</div>
		<div>Sat</div>
	</div>
	<div class="calendar-days-of-month">
		<div 
			class="calendar-other-month-day calendar-day" 
			v-for="n in (startingDayDayofWeek(month,year))">
			{{n+startingDay(month,year)}}
		</div>
		<div 
			class="calendar-in-month-day calendar-day" 
			v-for="n in numberDaysInMonth(month, year)"
			v-on:click="selectDay(n)">
			<span class='day-label' :class="{today:isToday(year,month,n)}">{{n}}</span>
			<div class="events">
				<draggable class="event-list" 
					:class="'dom-' + n"
					tag="ul" 
					group="items"
					v-on:end="dragEnd($event,n)">

					<li v-for="scheduleEvent in eventsByDay(year,month,n)" class="event-list-item" :class="{
							'continues-after':'continuesAfter' in scheduleEvent && scheduleEvent.continuesAfter,
							'started-before':'startedBefore' in scheduleEvent && scheduleEvent.startedBefore,
							'type-vacation': scheduleEvent.isVacation == 1,
							'type-sickday': scheduleEvent.isSickday == 1,
							'type-maintenance' : scheduleEvent.type == 'equipment-servicing',
							'type-job' : scheduleEvent.type == 'service' || scheduleEvent.type == 'project',
							'type-service' : scheduleEvent.type == 'service',
							'type-project' : scheduleEvent.type == 'project',
							'type-user-on-job' : scheduleEvent.type == 'user' && (scheduleEvent.job_id > 0 || scheduleEvent.service_id > 0)
						}">

						<div>
							<schedule-card-indicators 
								class="ml-1 mr-1" 
								:event-item="scheduleEvent"
								:selected-date="selectedDate">
							</schedule-card-indicators>
							<span class="event-color-blob"></span>
						</div>
						
						<div class="event-details">
							<div v-if="'eventTileDisplayFields' in scheduleSettings && scheduleSettings.eventTileDisplayFields.indexOf('entityName') >= 0">
								{{ scheduleEvent.description }}

								<template v-if="'attachedJobDescription' in scheduleEvent">{{ scheduleEvent.attachedJobDescription }}</template>
							</div>
							<div v-if="'eventTileDisplayFields' in scheduleSettings && scheduleSettings.eventTileDisplayFields.indexOf('startEndTime') >= 0">
								{{ scheduleEvent.startMoment.format("YYYY-MM-DD HH:mm") }} - {{ scheduleEvent.endMoment.format("YYYY-MM-DD HH:mm") }}
							</div>
							<div v-if="'eventTileDisplayFields' in scheduleSettings && scheduleSettings.eventTileDisplayFields.indexOf('customerName') >= 0">
								
								<template v-if="'Service' in scheduleEvent && scheduleEvent.Service && 'Customer' in scheduleEvent.Service && scheduleEvent.Service.Customer">
									{{ scheduleEvent.Service.Customer.name }}
								</template>
								<template v-else-if="'Job' in scheduleEvent && scheduleEvent.Job && 'Customer' in scheduleEvent.Job && scheduleEvent.Job.Customer">
									{{ scheduleEvent.Job.Customer.name }}
								</template>

							</div>
							<div v-if="'eventTileDisplayFields' in scheduleSettings && scheduleSettings.eventTileDisplayFields.indexOf('locationAddress') >= 0">
								
								<template v-if="'Service' in scheduleEvent && scheduleEvent.Service && 'Customer' in scheduleEvent.Service && scheduleEvent.Service.Customer">
									{{ formatLocationAddress(scheduleEvent.Service) }}
								</template>
								<template v-else-if="'Job' in scheduleEvent && scheduleEvent.Job && 'Customer' in scheduleEvent.Job && scheduleEvent.Job.Customer">
									{{ formatLocationAddress(scheduleEvent.Job) }}
								</template>
								
							</div>
							<span v-if="scheduleEvent.title"> ({{ scheduleEvent.title }})</span>
						</div>

					</li>
				</draggable>
			</div>
		</div>
		<div 
			class="calendar-other-month-day calendar-day" 
			v-for="n in (6-endingDayDayofWeek(month,year))">
			{{n}}
		</div>
	</div>
</div>
</template>
<script type="text/javascript">

import ScheduleMixins from "@/mixins/ScheduleMixins.js"
import ScheduleCardIndicators from "@/components/schedule/ScheduleCardIndicators"
import draggable from "vuedraggable"

export default {
	name: "MonthlyView",
	components: {
		ScheduleCardIndicators,
		draggable
	},
	props: [
		"selectedDate",
		"scheduleEvents",
		"equipmentServicing",
		"filtering"
	],
	mixins: [ScheduleMixins],
	data() {
		return {
			projectFiltering: false,
			serviceFiltering: false,
			equipmentFiltering: false,
			userFiltering: false,
			filters: {
				mainTypes: ["project","service","equipment","user","equipment-servicing"],
				projectIds: [],
				serviceIds: [],
				equipmentIds: [],
				userIds: []
			}
		}
	},
	watch: {
		filtering() {
			this.initFilteringValues()
		}
	},
	computed: {
		year() {
			return +this.moment(this.selectedDate).format("YYYY")
		},
		month() {
			return +this.moment(this.selectedDate).format("M")
		}
	},
	methods: {
		formatLocationAddress(entity) {
			if (!entity || !entity.address)
				return ""

			if (entity.city)
				return entity.address + ", " + entity.city

			return entity.address
		},
		initFilteringValues() {
			let vm = this
			Object.keys(this.filtering).forEach(key => {
				vm[key] = vm.filtering[key]
			})
		},
		getMonthName(monthInt) {
			return this.moment().month(monthInt).format("MMMM")
		},
		isToday(year,month,day) {

			if (typeof month == 'string')
				month = parseInt(month)

			if (typeof day == 'string')
				day = parseInt(day)

			if (month < 10)
				month = "0"+month
			if (day < 10)
				day = "0"+day

			let today = this.moment().format("YYYY-MM-DD")

			if (this.moment(today).isSame(year+"-"+month+"-"+day))
				return true
			else
				return false
		},
		numberDaysInMonth(month, year) {
			//decrement month because moment uses 0 based months
			month--

			return this.moment({year,month,day:1}).daysInMonth()
		},
		startingDayDayofWeek(month,year) {
			if (month == 0) {
				this.selectedMonth = month
			}
			if (year == 0) {
				year = this.moment().year()
				this.selectedYear = year
			}

			month = month-1

			return this.moment({year,month,day:1}).day()
		},
		startingDay(month, year) {

			let prevMonth = month-1
			let prevYear = year
			if (month == 1) {
				prevYear = year - 1
				prevMonth = 12
			}

			let numberDaysInMonth = this.numberDaysInMonth(prevMonth,prevYear)

			let firstSunday = numberDaysInMonth - this.startingDayDayofWeek(month,year)

			return firstSunday
		},
		endingDayDayofWeek(month,year) {
			if (month == 0) {
				month = this.moment().month()
				this.selectedMonth = month
			}
			if (year == 0) {
				year = this.moment().year()
				this.selectedYear = year
			}

			//decrement month for 0 based months
			let lastday = new Date(year,month-1,this.numberDaysInMonth(month,year))

			return lastday.getDay()
		},
		eventsByDay(year,month,day) {
			let vm = this

			let format = "YYYY-MM-DD hh:mm A"

			let theDayMoment = this.moment([year,month-1,day])

			if (!this.scheduleEvents)
				return []

			let scheduleEvents = this.scheduleEvents
				.map(scheduleEvent => {
					let obj = this.renderEventObj(scheduleEvent)

					let dayStart = this.moment([year,month-1,day,this.dayStart])
					let dayEnd = this.moment(dayStart).add(24,"hours")

					obj.startedBefore = obj.startMoment.isBefore(dayStart)
					obj.continuesAfter = obj.endMoment.isAfter(dayEnd)

					if (obj.type == 'user')
						obj.icon = "fa-user"
					else if (obj.type == 'equipment')
						obj.icon = "fa-truck"
					else if (obj.type == 'service')
						obj.icon = "fa-wrench"
					else if (obj.type == "project")
						obj.icon = "fa-cubes"

					return obj
				})
				.filter(scheduleEvent => {
					let dayStart = this.moment([year,month-1,day,this.dayStart])
					let dayEnd = this.moment(dayStart).add(24,"hours")

					if (vm.filters.mainTypes.indexOf(scheduleEvent.type) == -1)
						return false

					let include = false
					if (scheduleEvent.startMoment.isSameOrAfter(dayStart) && scheduleEvent.startMoment.isBefore(dayEnd)) //starts on day
						include = true
					else if (scheduleEvent.startMoment.isBefore(dayStart) && scheduleEvent.endMoment.isAfter(dayStart)) //started before day but ends during day
						include = true
					else if (scheduleEvent.startMoment.isBefore(dayStart) && scheduleEvent.endMoment.isAfter(dayEnd)) //runs right through day
						include = true

					if (include) {
						if (scheduleEvent.type == 'project' && vm.projectFiltering && vm.filters.projectIds.length > 0)
							include = vm.filters.projectIds.find(id => id == scheduleEvent[scheduleEvent.entityKey])

						if (scheduleEvent.type == 'service' && vm.serviceFiltering && vm.filters.serviceIds.length > 0) 
							include = vm.filters.serviceIds.find(id => id == scheduleEvent[scheduleEvent.entityKey])

						if (scheduleEvent.type == 'user' && vm.userFiltering && vm.filters.userIds.length > 0)  
							include = vm.filters.userIds.find(id => id == scheduleEvent[scheduleEvent.entityKey])
					}

					return include
				})
				.sort((a,b) => {
					if (a.startMoment.isAfter(b.startMoment))
						return 1
					else
						return -1
				})

			//mutate then merge in equipment servicing 
			if (vm.filters.mainTypes.indexOf("equipment-servicing") >= 0) {
				let equipmentServicing = this.equipmentServicing.map(eq => {
					eq.type = 'equipment-servicing'

					eq.startMoment = vm.moment(eq.next_service_date+" 00:00")
					eq.endMoment = vm.moment(eq.next_service_date).endOf("day")

					return eq
				}).filter(eq => eq.next_service_date == vm.moment([year,month-1,day]).format("YYYY-MM-DD"))

				scheduleEvents = [
					...scheduleEvents,
					...equipmentServicing
				]
			}

			return this.sortEventsByRelated(scheduleEvents)
		},
		sortEventsByRelated(scheduleEvents) {
			let vm = this
			/*
				Should be sorted by:
				Project
					Users
					Equipment
				Service
					Users
					Equipment
				User Events
				Equipment Events
			*/

			//sort into entity types first

			let users = scheduleEvents.filter(ev => ev.type == 'user')
			let equipment = scheduleEvents.filter(ev => ev.type == 'equipment')
			let projects = scheduleEvents.filter(ev => ev.type == 'project')
			let services = scheduleEvents.filter(ev => ev.type == 'service')
			let eqServicing = scheduleEvents.filter(ev => ev.type == 'equipment-servicing')

			let sorted = []
			projects.sort((a,b) => {
				if (a.Job.job_num > b.Job.job_num)
					return 1
				return -1
			})
			services.sort((a,b) => {
				if (a.Service.job_num > b.Service.job_num)
					return 1
				return -1
			})
			users.sort((a,b) => {
				if (a.description.toUpperCase() > b.description.toUpperCase())
					return 1
				return -1
			})
			equipment.sort((a,b) => {
				if (a.description > b.description)
					return 1
				return - 1
			})

			projects.forEach(projectEvent => {
				sorted.push(projectEvent)

				//find all users attached to this project
				users
					.filter(userEvent => userEvent.job_id == projectEvent[projectEvent.entityKey])
					.forEach(userEvent => {
						let clonedEvent = vm.deepCloneEventObj(userEvent)

						sorted.push(clonedEvent)
					})

				//find all equipment attached to this project
				equipment
					.filter(eqEvent =>  eqEvent.job_id == projectEvent[projectEvent.entityKey])
					.forEach(eqEvent => {

						let clonedEvent = vm.deepCloneEventObj(eqEvent)

						sorted.push(clonedEvent)
					})
			})

			services.forEach(serviceEvent => {
				sorted.push(serviceEvent)

				//find all users attached to this service
				users
					.filter(userEvent => userEvent.job_id == serviceEvent[serviceEvent.entityKey])
					.forEach(userEvent => {
						let clonedEvent = vm.deepCloneEventObj(userEvent)

						sorted.push(clonedEvent)
					})

				//find all equipment attached to this project
				equipment
					.filter(eqEvent =>  eqEvent.job_id == serviceEvent[serviceEvent.entityKey])
					.forEach(eqEvent => {

						let clonedEvent = vm.deepCloneEventObj(eqEvent)

						sorted.push(clonedEvent)
					})
			})

			//next is the equipment servicings
			sorted = [
				...sorted,
				...eqServicing
			]

			//all the standalone user events
			sorted = [
				...sorted,
				...users.filter(userEvent => userEvent.job_id == 0 && userEvent.service_id == 0)
			]

			//all the standalone equipment events
			sorted = [
				...sorted,
				...equipment.filter(eqEvent => eqEvent.job_id == 0 && eqEvent.service_id == 0)
			]

			return sorted
		},
		selectDay(n) {
			this.$emit("daySelected",this.moment([this.year,this.month-1,n]).format("YYYY-MM-DD"))
		},
		dragEnd(arg,fromDay) {
			let vm = this

			//find the event
			let events = this.eventsByDay(this.year,this.month,fromDay)

			if (events.length >= arg.oldIndex + 1) {
				let event = events[arg.oldIndex]

				//find "to" day of month
				let toClass = Array.from(arg.to.classList).find(cl => cl.search("dom-") >= 0)
				let toDayOfMonth = toClass.replace("dom-","");

				if (+toDayOfMonth < 10)
					toDayOfMonth = "0" + toDayOfMonth

				if (+fromDay < 10)
					fromDay = "0" + fromDay

				let fromDate = this.moment(this.year + "-" + this.month + "-" + fromDay)
				let toDate = this.moment(this.year + "-" + this.month + "-" + toDayOfMonth)

				//keeping the same time, swap "from" date to "to" date by finding the difference in days between from and to, and adding that to the old startMoment/endMoment

				let diffInDays = toDate.diff(fromDate,"days")

				let start_time = event.startMoment.add(diffInDays,"days").format("YYYY-MM-DD HH:mm:ss")
				let end_time = event.endMoment.add(diffInDays,"days").format("YYYY-MM-DD HH:mm:ss")
				
				let payload = {
					 id: event.id,
					 start_time,
					 end_time
				}

				this.postData("ScheduleEvent/save",payload,true).then(response => {
					if (response.success)
						vm.alertSaved("Event rescheduled")
				})
			}
		}
	},
	created() {
		
	}
}
</script>

<style type="text/css" scoped>
	
	.days-of-week-headings {
		display: flex;
		flex: row;
		justify-content: space-around;
	}

	.days-of-week-headings div {
		padding: 10px;
		text-align: center;
		font-weight: bold;
		flex-grow: 1;
		margin: 1px;
		width: calc(14.28% - 2px);
	}

	.calendar-days-of-month {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		background-color: #fdfdfd;
	}

	.calendar-days-of-month .calendar-day {
		width: calc(14.28% - 2px);
		border: 1px solid #e0e0e0;
		min-height: 70px;
		padding: 3px;
		margin: 1px;
	}

	.calendar-day:hover {
		cursor: pointer;
		background-color: #EAE9E7;
	}

	.calendar-other-month-day {
		color: #808080;
	}

	.calendar-day {
		position: relative;
	}

	.calendar-day .day-label {
		position: absolute;
		top: 2px;
		left: 3px;
	}

	.calendar-day .day-label.today {
		background-color: #e0e0e0;
	}

	.calendar-day .events {
		margin-left: 0;
		margin-top: 25px;
		padding: 0;
		padding-top: 0;
		padding-bottom: 0;
		font-size: 10pt;
		width: 100%;
		height: calc(100% - 25px);
	}

	.event-list {
		list-style: none;
		padding: 0;
		margin: 0;
		width: 100%;
		height: 100%;
	}

	.event-list-item {
		padding: 3px;
		padding-left: 5px;
		padding-right: 5px;
		display: flex;
		border-radius: 5px;
		color: #404040;
		border: 1px solid rgba(0,0,0,.125);
	}

	.event-list-item.continues-after {
		border-bottom-right-radius: 0;
		border-top-right-radius: 0;
	}

	.event-list-item.started-before {
		border-bottom-left-radius: 0;
		border-top-left-radius: 0;
	}

	.event-list-item.type-vacation {
		border-top: 1px solid green;
		border-bottom: 1px solid green;
		border-right: 12px solid green;
		border-left: 12px solid green;
		background-color: rgba(0,128,0,0.1);
	}

	.event-list-item.type-sickday {
		border-top: 1px solid rgb(165, 98, 24);
		border-bottom: 1px solid rgb(165, 98, 24);
		border-right: 12px solid rgb(165, 98, 24);
		border-left: 12px solid rgb(165, 98, 24);
		background-color: rgb(165, 98, 24,0.1)
	}

	.event-list-item.type-project {
		background-color: #7c61f31c;
	}

	.event-list-item.type-service {
		background-color: #61f3af1c;
	}

	.event-list-item.type-maintenance {
		border-top: 1px solid #fdbf77;
		border-bottom: 1px solid #fdbf77;
		border-right: 12px solid #fdbf77;
		border-left: 12px solid #fdbf77;
		background-color: rgba(253,191,119,0.1);
	}

	.event-list-item.type-user-on-job {
		border-top: 1px solid #e0e0e0;
		border-bottom: 1px solid #e0e0e0;
		border-right: 12px solid #e0e0e0;
		border-left: 12px solid #e0e0e0;
		background-color: rgba(100,100,100,0.05);
	}

	.event-list-item.started-before {
		border-left: none;
	}

	.event-list-item.continues-after {
		border-right: none;
	}

	/*.event-list-item:hover {
		cursor: pointer;
		background-color: #EAE9E7
	}*/

	.event-list-item .event-color-blob {
		width: 10px;
		height: 10px;
		border-radius: 50%;
		margin-right: 5px;
		display: inline-block;
	}

	.event-list-item .fa {
		margin-right: 3px;
		margin-left: -3px;
	}

	@media (max-width: 500px) {

		.event-list-item .event-details {
			display: none;
		}

	}

</style>